import styled, { css } from 'styled-components';
import {PcBox as BasePcBox, MobileBox as BaseMobileBox} from './useful-links-item.default.box'
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';

const common = css`
    margin: 1rem 0;
    border: none;
    &:after {
        right: 15px;
        background-size: 1036px;
    }
`;

const PcBox = styled(BasePcBox)`
    ${common}
    font-size: 1.4rem;
    &:first-child {
        margin-top: 1rem;
    }
    &:after {
        background-position: -446px -370px;
        top: 1.15rem;
        width: 10px;
        height: 15px;
    }
`;

const MobileBox = styled(BaseMobileBox)`
     ${common}
     ${({theme}) => theme.font.presets.body};
     &:after {
        background-position: -629px -525px;
        background-size: auto;
        height: 2rem;
     }
`;

export const UsefulLinksItemCasino777Box = styledByDevice(PcBox, MobileBox);